"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStylableFileProcessor = void 0;
const cached_process_file_1 = require("./cached-process-file");
const parser_1 = require("./parser");
const stylable_processor_1 = require("./stylable-processor");
function createStylableFileProcessor({ fileSystem, onProcess, resolveNamespace, cssParser = parser_1.cssParse, cache, createDiagnostics, }) {
    return (0, cached_process_file_1.cachedProcessFile)((from, content) => {
        return new stylable_processor_1.StylableProcessor(createDiagnostics === null || createDiagnostics === void 0 ? void 0 : createDiagnostics(from), resolveNamespace).process(cssParser(content, { from }));
    }, (resolvedPath) => {
        return fileSystem.readFileSync(resolvedPath, 'utf8');
    }, onProcess && [onProcess], cache);
}
exports.createStylableFileProcessor = createStylableFileProcessor;
//# sourceMappingURL=create-stylable-processor.js.map